// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_1PZXY","content":"style_content_1s1GM"};